import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'lin-remaining-progress-bar',
  template: `
    {{ title }}
    @if (currentValue) {
      <mat-progress-bar mode="determinate" [value]="value" [class.accent]="isNegativeValue"></mat-progress-bar>
    }
  `,
  styles: [
    `
      /* TODO(mdc-migration): The following rule targets internal classes of progress-bar that may no longer apply for the MDC version. */
      .accent ::ng-deep .mat-progress-bar-fill::after {
        background-color: var(--main-accent-color);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RemainingProgressBarComponent implements OnInit {
  value: number
  isNegativeValue: boolean

  @Input() title: string
  @Input() baseValue: number
  @Input() currentValue: number

  ngOnInit(): void {
    this.currentValue && this.initValue()
  }

  initValue(): void {
    this.isNegativeValue = Math.sign(this.currentValue) === (0 || -1)
    this.value = this.isNegativeValue ? 100 : (this.currentValue * 100) / this.baseValue
  }
}
